import { render, staticRenderFns } from "./AiImageS.vue?vue&type=template&id=2d184bdc&scoped=true&"
import script from "./AiImageS.vue?vue&type=script&lang=js&"
export * from "./AiImageS.vue?vue&type=script&lang=js&"
import style0 from "./AiImageS.vue?vue&type=style&index=0&id=2d184bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d184bdc",
  null
  
)

export default component.exports